import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_form = _resolveComponent("b-form");
  return _openBlock(), _createBlock(_component_b_form, _mergeProps(_ctx.$attrs, {
    onSubmit: _cache[0] || (_cache[0] = $event => $options.onSubmit($event))
  }), {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
    _: 3
  }, 16);
}